<template>
  <div id="service-progress">
    <div class="top">
      <img src="@/assets/images/progress/top.png" alt="">
      <span>服务进度</span>
    </div>
    <ul>
      <li :class="progress.progress.join ? 'active' : ''">
        <div class="icon">
          <img src="@/assets/images/progress/step1.png" alt="">
        </div>
        <div class="content">
          <p class="label">{{progress.progress_label.join}}</p>
          <p class="time">{{progress.progress.join}}</p>
        </div>
      </li>
      
      <li :class="progress.progress.family_need ? 'active' : ''">
        <div class="icon">
        <img src="@/assets/images/progress/step3.png" alt="">
        </div>
        <div class="content">
          <p class="label">{{progress.progress_label.family_need}}</p>
          <p class="time">{{progress.progress.family_need}}</p>
        </div>
      </li>
      <li :class="progress.progress.follow ? 'active' : ''">
        <div class="icon">
        <img src="@/assets/images/progress/step2.png" alt="">
        </div>
        <div class="content">
          <p class="label">{{progress.progress_label.follow}}</p>
          <p class="time">免费领取课程，第一时间推送方案</p>
          <p class="time">{{progress.progress.follow}}</p>
        </div>
      </li>
      <li :class="progress.progress.plan ? 'active' : ''">
        <div class="icon">
        <img src="@/assets/images/progress/step4.png" alt="">
        </div>
        <div class="content">
          <p class="label">{{progress.progress_label.plan}}</p>
          <p class="time">{{progress.progress.plan}}</p>
        </div>
      </li>
      <li :class="progress.progress.policy ? 'active' : ''">
        <div class="icon">
        <img src="@/assets/images/progress/step5.png" alt="">
        </div>
        <div class="content">
          <p class="label">{{progress.progress_label.policy}}</p>
          <p class="time">{{progress.progress.policy}}</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
// 服务进度
export default {
  name: 'service-progress',
  data(){
    return {
      progress:{
        progress:{},
        progress_label:{}
      }
    }
  },
  methods: {
    // 获取服务进度
    getProgress(){
      this.axios({
        method: 'GET',
        url: '/user/progress',
        headers: {
          'Authorization': `Bearer ${this.Global.getCookie('token')}` 
        }
      }).then((res) => {
        if(res.data.code == 0){
          this.progress = res.data.data
        }
      })
    }
  },
  created(){
    this.getProgress()
    this.Global.getShareConfig({
      title: '点击获取私人家庭保障方案',
      desc: '一对一咨询，分析风险，定制保障方案，让你买的放心，保的全面'
    },this)
  }
}
</script>

<style scoped>
  #service-progress{
    padding: 0.8125rem 0.625rem;
  }
  .top{
    background: url('../assets/images/personal/top-bg.png') no-repeat;
    background-size: 100%;
    border-radius: 0.4375rem;
    padding: 1rem 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 1.4375rem;
  }
  .top img{
    width: 1.6875rem;
  }
  .top span{
    font-size: 0.875rem;
    font-weight: 400;
    color: #FFF;
    margin-top: 0.875rem;
  }
  ul li{
    margin-bottom: 3.09rem;
    display: flex;
    align-items: center;
  }
  ul li .icon{
    width: 3.4375rem;
    height: 3.4375rem;
    border-radius: 50%;
    position: relative;
    background: #DCDCDC;
    margin-right: 3.125rem;
    margin-left: 2.5rem;
  }
  ul li .icon::before{
    content: '';
    width: 0.25rem;
    height: 2.125rem;
    border-radius: 0.125rem;
    background: #DCDCDC;
    position: absolute;
    top: -2.5rem;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
  }
  ul li:first-child .icon::before{
    display: none;
  }
  ul li.active .icon,
  ul li.active .icon::before{
    background: rgba(255,161,39,1);
  }
 
  ul li .icon img{
    width: auto;
    height: 1.75rem;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
  ul li .content{
    flex: 1;
    line-height: 1.5rem;
  }
  ul li .content .label{
    font-size: 1.0625rem;
    font-weight: 400;
    color: #1D1D1D;
  }
  ul li .content .time{
    font-size: 0.75rem;
    font-weight: 400;
    color: #A7A7A7;
  }
</style>